import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import session from "./modules/session";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  storage: localStorage
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    session
  },
  plugins: [vuexPersist.plugin]
});
